/**
 * Criterio único de orden activa en el MES: Status === 'INPROGRESS'.
 * No usar fechas SAP (StartedAt/FinishedAt) para determinar si una orden está activa.
 */

export function isOrderActiveInMES(order) {
  if (!order) return false
  return (order.Status || order.status) === 'INPROGRESS'
}

export function getActiveOrderFromList(orders = []) {
  return orders.find(isOrderActiveInMES) ?? null
}

export function sortOrdersWithActiveFirst(orders = []) {
  return [...orders].sort((a, b) => {
    const aActive = isOrderActiveInMES(a)
    const bActive = isOrderActiveInMES(b)
    if (aActive && !bActive) return -1
    if (!aActive && bActive) return 1
    return 0
  })
}

export function getOrderDisplayStatus(order) {
  const status = order?.Status || order?.status || 'DRAFT'
  if (status === 'INPROGRESS') {
    return { label: 'En Producción', badgeClass: 'bg-green-600 text-white' }
  }
  if (status === 'COMPLETED') {
    return { label: 'Finalizada', badgeClass: 'bg-gray-600 text-gray-200' }
  }
  if (status === 'CANCELLED') {
    return { label: 'Cancelada', badgeClass: 'bg-gray-600 text-gray-200' }
  }
  return { label: 'Pendiente', badgeClass: 'bg-amber-600 text-white' }
}
